import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import ErrorPage from './ErrorPageView';
import { Contact } from './styles';
import AppContext from '../AppContext';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';
import { externalHostSelector } from '../ConsumerArea/ConsumerAreaSelector';
import { EXTERNAL_HOST } from '../ConsumerArea/ConsumerAreaConstants';

const FatalErrorView = () => {
  useDocumentTitle('Unknown Error');

  const appContext = useContext(AppContext);

  const externalHost = useSelector(externalHostSelector);

  const hideEmail = [EXTERNAL_HOST.MONETA, EXTERNAL_HOST.WEALTHCARE, EXTERNAL_HOST.CARSON].includes(
    externalHost,
  );

  return (
    <ErrorPage
      icon="fas fa-rocket"
      title="We have a problem!"
      message={
        <>
          We&#8217;re sorry, an unknown error has occurred.
          <br />
          Please try again in a few minutes.
          {!hideEmail && (
            <>
              If the error persists{' '}
              <Contact href="mailto:financialplanning@orion.com">contact us</Contact> for support.
            </>
          )}
        </>
      }
      button={{
        text: 'Go to Homepage',
        onClick: () => {
          ADV.util.Router.go2(appContext.defaultController, appContext.defaultParams);
        },
      }}
    />
  );
};

export default FatalErrorView;
